var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('p',[_vm._v(_vm._s(_vm.label))]),_c('button',{on:{"click":_vm.storeLocale}},[_vm._v("Change Language")])])}
var staticRenderFns = []

export { render, staticRenderFns }